<template>
  <div class="bookings   pt-4">
    <page-header title="Process Handoff" :back="{ path: '/operations/dispatch/' }"
      breadcrumb="Bookings & Shipments > Dispatch Management > Handoff " />

    <div class=" bkgrnd  mt-4">
      <div class="flex-wrap flex  metrics-wrap">
        <div class="py-2">
          <div class="flex items-center  gap-2 metrics-wrap-cover">
            <img class="" src="../newdispatch/icons/handoffMetricsIcon.svg" alt="">
            <div class="metrics-content">
              <p>Dispatch ID:{{ dispatch?.dispatchReference }}</p>
              <!-- <h4> ₦ </h4> -->
            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex gap-2 items-center  metrics-wrap-cover">
            <img class="ml-2" src="../newdispatch/icons/handoffMetricsIcon.svg" alt="">
            <div class="metrics-content">
              <p>Consolidation ID: {{ dispatch?.consolidation?.consolidationReference }}</p>
              <!-- <h4> ₦ </h4> -->
            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex items-center   gap-2  metrics-wrap-cover">
            <img class="ml-2" src="../newdispatch/icons/handoffIcon_1.svg" alt="">
            <div class="metrics-content">
              <p>Shipment Count: {{ dispatch?.consolidation?.shipments?.length || 0 }}</p>
              <!-- <h4> ₦ </h4> -->
            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex items-center  gap-2 metrics-wrap-cover">
            <img class="ml-2" src="../newdispatch/icons/handoffIcon_1.svg" alt="">
            <div class="metrics-content">
              <p>Item Count: {{ totalPackages }}</p>
              <!-- <h4> ₦ </h4> -->
            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex items-center   gap-2  ">
            <img class="ml-2" src="../newdispatch/icons/handoffIcon_2.svg" alt="">
            <div class="metrics-content">
              <p>Total weight: {{ totalEstimatedWeight }} kg</p>
              <!-- <h4> N</h4> -->
            </div>
          </div>
        </div>
      </div>


      <div class="business-status pt-4">
        <div class="">
          <div class="flex  justify-between items-center mb-8 pl-2">
            <div class="box-cover  flex items-center">
              <div :class="['color-box', { 'active': selected === 'Yes' }]"     @click="setAllStatuses('Good Condition')"></div>
              <p class="ml-2 text-[64px] font-bold text-[#383F51]">Set all delivery status to Good Condition</p>
            </div>
            <div class="box-cover  flex items-center">
              <div :class="['color-box', { 'active': selected === 'No' }]" @click="setAllStatuses('Bad Condition')"></div>
              <p class="ml-2 text-[14px] font-bold text-rose-500">Set all delivery status to Bad Condition</p>
            </div>
          </div>
        </div>
      </div>

      <div class="table-wrapper" id="table-wrapper">
        <table class="custom-table responsive-table">
          <thead>
            <tr>
              <th class="shipping-ref-col width-sm">Shipping ID</th>
              <th>Service/ EDD</th>
              <th class="text-center">Weight</th>
              <th>Item Count</th>
              <th>Receiver</th>
              <th>Destination</th>
              <th>Delivery Status</th>
            </tr>
          </thead>
        
          <tbody>
            <tr v-for="(handoff) in allPackages" :key="handoff.id" class="cursor-pointer">

              <td>
                <span>{{
                  handoff ? handoff.reference : "N/A"
                }}</span><span>MuleEx</span>
              </td>

              <td>
                <span>{{
                  handoff ? handoff.reference : "N/A"
                }}</span><span>MuleEx</span>

              </td>

              <td class="text-center">
                {{ handoff?.estimatedWeight || "N/A" }}
              </td>

              <td class="">
                {{ handoff ? handoff.quantity : "N/A" }}

              </td>

              <td>
                {{ handoff?.receiver || "N/A" }}

              </td>

              <td>
                {{ handoff?.destination || "N/A" }}
              </td>

            <td>
                <select class="status-select" v-model="packageStatuses[handoff.id]">
                  <option v-for="status in packageStatus" :key="status" :value="status">
                    {{ status }}
                  </option>
                </select>
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>

       <div class="next-submit flex justify-end mt-4  rounded-9">
        <base-button text="Process Hand-off" @click="proceed" />
        <!-- <base-button text="Process Hand-off" @click="proceed" :disabled="!isFormValid" /> -->
      </div>


    </div>

    <!-- <ShippingLabel @create-dispatch="createDispatch" @open-dispatch-modal="openDispatchModal"
      :show-modal="showShippinLabel" @close-modal="showShippinLabel = false"
      :selcetdDispatchDetail="selcetdDispatchDetail" :selecetedDispatch="selecetedDispatch"
      :longHaulDispatchables="longHaulDispatchables" @open-update-status-modal="updateStatus" />


    <DispatchModal @go-back="goBack" :selecetedDispatch="selecetedDispatch" :show-modal="showDispatchModal"
      @close-modal="showDispatchModal = false" :selcetdDispatchDetail="selcetdDispatchDetail"
      :dispatchSummary="dispatchSummary" :fleetId="fleetId" /> -->
    <!-- 
    <UpdateConsolidationStatusModal :showmodal="showUpdateStatusModal" @close-modal="showUpdateStatusModal = false"
      :selectedItem="selectedItem" @refetchBooking="refetchOverview" /> -->
       <ProcessHandOffModal :showModal="processhandoffModal" :dispatch="processHandoffPayload"
      @close-modal="processhandoffModal = false" />

  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
// import Yes from './modules/Yes.vue';
// import No from './modules/No.vue';
// import ShippingLabel from "../Modals/ShippingLabel.vue";
// import DispatchModal from "../Modals/DispatchModal.vue";
// import UpdateConsolidationStatusModal from "../Modals/update-consolidation-status.vue";
// import UpdateConsolidationStatusModal from "../Modals/update-consolidation-status.vue";
import ProcessHandOffModal from "../Modals/ProcessHandoffModal";


export default {
  components: {
    // Yes,
    // No,
    PageHeader,
     ProcessHandOffModal
    // ShippingLabel,
    // DispatchModal,
    // UpdateConsolidationStatusModal
  },

  data() {
    return {
      selected: 'Yes',
      // selectedPackageStatus: null,
      packageStatuses: {}, // stores status for each package
      packageStatus: ['Good Condition', 'Bad Condition'],
      processhandoffModal :  false
    };
  },
  mounted() {
    console.log("logged  params", this.$route.query.dispatch);
     this.allPackages.forEach(pkg => {
    this.$set(this.packageStatuses, pkg.id, "Good Condition");
  });
  //   this.allPackages.forEach(pkg => {
  //   this.packageStatuses[pkg.id] = "Good Condition";
  // });
  },
  computed: {
    // processHandoffPayload() {
    //   return {
    //     dispatchId: this.dispatch.id,
    //     dispatchReference: this.dispatch.dispatchReference,
    //     consolidationId: this.dispatch.consolidation.id,
    //     consolidationReference: this.dispatch.consolidation.consolidationReference,

    //     packages: this.allPackages.map(pkg => ({
    //       packageId: pkg.id,
    //       shippingReference: pkg.reference,
    //       quantity: pkg.quantity,
    //       estimatedWeight: pkg.estimatedWeight,
    //       receiver: pkg.receiver,
    //       destination: pkg.destination,

    //       deliveryStatus:
    //         this.packageStatuses[pkg.id] || "Good Condition"
    //     }))
    //   };
    // },
    processHandoffPayload() {
      const dispatch = this.dispatch;

      if (!dispatch) {
        return null;
      }

      return {
        dispatchId: dispatch.id,
        dispatchReference: dispatch.dispatchReference,
        consolidationId: dispatch.consolidation?.id,
        consolidationReference: dispatch.consolidation?.consolidationReference,

        packages: this.allPackages.map(pkg => ({
          packageId: pkg.id,
          shippingReference: pkg.reference,
          quantity: pkg.quantity,
          estimatedWeight: pkg.estimatedWeight,
          receiver: pkg.receiver,
          destination: pkg.destination,
          deliveryStatus:
            this.packageStatuses[pkg.id] || "Good Condition"
        }))
      };
    },

    dispatch() {
      return this.$route.query.dispatch;
    },
    totalPackages() {
      return (this.dispatch?.consolidation?.shipments || []).reduce((total, shipment) => {
        const shipmentCount = (shipment.packagees || []).reduce((sum, pkg) => {
          return sum + Number(pkg.quantity || 0);
        }, 0);

        return total + shipmentCount;
      }, 0);

    },
    // totalPackages() {


    //   const shipments = this.dispatch?.consolidation?.shipments || [];

    //   return shipments.reduce((total, shipment) => {
    //     return total + (shipment.packagees?.length || 0);
    //   }, 0);
    // },
    allPackages() {
      //  const consolidation = this.dispatch?.consolidation || {};
      //  const destinationTerminal = consolidation.destinationTerminal || {};
      return (this.dispatch?.consolidation?.shipments || []).flatMap(
        shipment =>
          (shipment.packagees || []).map(pkg => ({
            ...pkg,
            reference: shipment.reference,
            receiver: shipment?.location?.contactName,
            destination: shipment?.location?.address?.address
          }))
      );
    },
  
    shipments() {
      return this.dispatch?.consolidation?.shipments || [];
    },
    totalEstimatedWeight() {
      return (this.dispatch?.consolidation?.shipments || []).reduce((total, shipment) => {
        const shipmentWeight = (shipment.packagees || []).reduce((sum, pkg) => {
          return sum + Number(pkg.estimatedWeight || 0);
        }, 0);

        return total + shipmentWeight;
      }, 0);
    }
  },

  methods: {
    // proceed()  {
    //   this.processhandoffModal  =  !this.processhandoffModal
    // },
    proceed() {
      if (!this.dispatch) {
        console.warn("No dispatch data available");
        return;
      }

      console.log("Process handoff payload:", this.processHandoffPayload);

      this.processhandoffModal = true;
    },
  setAllStatuses(status) {
    // Update the selected radio
    this.selected = status === "Good Condition" ? "Yes" : "No";

    // Update every package
    this.allPackages.forEach(pkg => {
      this.$set(this.packageStatuses, pkg.id, status);
    });
  },

    // selectPackageStatus(packageId, status) {
    //   this.$set(this.packageStatuses, packageId, status);
    // },
    // selectPackageStatus(packageId, status) {
    //   this.packageStatuses[packageId] = status;
    // },
    // selectCountryOption(item) {
    //   this.selectedPackageStatus = item
    // },
    
    selectOption(option) {
      this.selected = option;
    },
    
  },

};

</script>

<style lang="scss" scoped>
.status-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #FAFBFF;
  outline: none;
  cursor: pointer;
}


.bkgrnd {
  // background: #FAFBFF;
  background: #FFFFFF;
  padding: 1rem;
  border-radius: 8px;
}

.metrics-wrap {
  // border: 1px dashed #878E99;

}

// .metrics-wrap>:nth-child(1) {
//   width: 22%;

// }

// .metrics-wrap>:nth-child(2) {
//   width: 22%;

// }

// .metrics-wrap>:nth-child(3) {
//   width: 20%;

// }

// .metrics-wrap>:nth-child(4) {
//   width: 18%;

// }

// .metrics-wrap>:nth-child(5) {
//   width: 18%;

// }

.metrics-wrap>div {
  width: 20%;
  // align-items: center;
  background: #FAFBFF;
}

.metrics-wrap>:nth-child(1) {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.metrics-wrap>:nth-child(4) {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.metrics-wrap-cover {
  border-right: 1px dashed #4142455C;
  // justify-content: space-between;
}


.metrics-content>p {
  color: #7A90A7;
  font-weight: 700;
  font-size: 14px;
}

// .metrics-content>h4 {
//   color: #383F51;
//   font-weight: 600;
//   font-size: 16px;
// }

.business-status>:nth-child(1)>:nth-child(1) {
  width: 45%;
}

.color-box.active {
  background-color: #FFA600;
}

.color-box {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  border: 1px solid #C5C4D4;
  cursor: pointer;
}

.box-cover>p {
  color: #383F51;
  font-size: 14px;
  font-weight: 400;
}

#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 8px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}

.custom-table {
  margin: 0;
}

th {
  padding: 0.75rem;
  min-width: 10rem;
  color: rgba(25, 48, 77, 0.7);
  font-weight: 500;
}

// .width-md {
//   min-width: 5rem;
// }

// .width-sm {
//   min-width: 8rem;
// }

// .width-xs {
//   min-width: 3rem !important;
// }

td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 0.75rem;
  vertical-align: top;

  span {
    display: block;
  }

  span:last-of-type {
    font-weight: normal;
    color: #10233e;
    opacity: 0.6;
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}

.shipping-option-col {
  width: 16%;
}

.shipping-ref-col {
  width: 13%;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
</style>
